export default "__VITE_ASSET__CuMDLykR__"